import inlineQuantityEditorFactory from "./inlineQuantityEditorFactory.js";

export default inlineQuantityEditorFactory(false);
